var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59625 11.9063L3.46875 8.77875L2.40375 9.83625L6.59625 14.0288L15.5962 5.02875L14.5387 3.97125L6.59625 11.9063Z",
    fill: "#D3D7D9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check-icon.ffd78d754a2a561ba92b22010181b7ac.svg";